export default {"src":"/_next/static/media/pillWithBox_64.d049da84.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};